var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"change-icon-button",attrs:{"variant":"link"},on:{"click":_vm.toggle}},[_c('b-icon',{style:(_vm.iconStyle),attrs:{"icon":_vm.isActive ? _vm.iconB : _vm.iconA}}),(_vm.isActive)?_c('span',[_vm._t("active")],2):_c('span',[_vm._t("inactive")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }